import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MobileMenu from "./Menu/MobileMenu";
import useFullPageLoader from "../../hooks/useFullPageLoader";

import {
  createWeb3Modal,
  defaultConfig,
  useWeb3Modal,
  useWeb3ModalProvider,
  useWeb3ModalAccount,
  useDisconnect,
} from "@web3modal/ethers/react";
import { RiNftLine } from "react-icons/ri";
import { TbParachute } from "react-icons/tb";
import { RiAuctionLine } from "react-icons/ri";
import { IoHomeOutline } from "react-icons/io5";
import { projectId } from "../../config/BackendUrl";
import { getUserByAddress } from "../../hooks/User";
import { BrowserProvider } from "ethers";
import { useDispatch } from "react-redux";
import Logo from "../../assets/img/logos/dtoc-logo.png";
import { DefaultProfile } from "../../assets/img";
import { setValue } from "../../Store/store";
import { CgProfile } from "react-icons/cg";
import { BiHeart, BiLogOutCircle } from "react-icons/bi";
import { BsFillMoonFill, BsGrid3X3 } from "react-icons/bs";
import { MdContentCopy, MdCreate } from "react-icons/md";
import { AiFillSetting, AiOutlineMenu, AiOutlineRight } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { Button, Modal } from "react-bootstrap";
import { setProvider, setWalletAddress } from "../../redux/actions/headerActions";
import { FaWallet, FaSignInAlt, FaSearch, FaArrowLeft, FaTimes, FaBars } from "react-icons/fa";
import { GweiToether } from "../../hooks/Tokenhook";
import { toast, ToastContainer } from "react-toastify";

const HomesMenu = [
  {
    icon: <RiNftLine />,
    title: "NFT",
    link: "/mint",
  },
  {
    icon: <IoHomeOutline />,
    title: "Collection",
    link: "/collectionAdd",
  },
  {
    icon: <TbParachute />,
    title: "Air Droping",
    link: "/drop",
  },
  {
    icon: <RiAuctionLine />,
    title: "Auction",
    link: "/auction",
  },
];
const PagesMenu = [
  {
    title: "Home",
    link: "/",
  },
  {
    title: "Marketplace",
    link: "marketplace",
  },
  // {
  //   title: 'Profile',
  //   link: 'profile',
  // },
  {
    title: "Collection",
    link: "collections",
  },
  {
    title: "Auction",
    link: "live-auctions",
  },
  {
    title: "Launchpad",
    link: "launchpad",
  },
  {
    title: "Docs",
    link: "docs",
  },
];


const mainnet = {
  chainId: 1,
  name: "Ethereum",
  currency: "ETH",
  explorerUrl: "https://etherscan.io",
  rpcUrl: "https://cloudflare-eth.com",
};

const sepolia = {
  chainId: 11155111,
  name: "Sepolia test network",
  currency: "SepoliaETH",
  explorerUrl: "https://sepolia.etherscan.io",
  rpcUrl: "https://sepolia.infura.io/v3/b8d48fc740104848a6133989ffafe35f",
};

const Linea = {
  chainId: 59140,
  name: "Linea Goerli test network",
  currency: "LineaETH",
  explorerUrl: "https://goerli.lineascan.build",
  rpcUrl: "https://linea-goerli.infura.io/v3/b8d48fc740104848a6133989ffafe35f",
};

const metadata = {
  name: "My Website",
  description: "My Website description",
  icons: [
    "https://dtoc.infura-ipfs.io/ipfs/QmPdw6iGVsaQekMqdhCKzDLVCVPJ5N6HTAi4Eg2B6E6uc5",
  ],
};

const ethersConfig = defaultConfig({
  metadata,
});

createWeb3Modal({
  ethersConfig,
  chains: [mainnet, sepolia, Linea],
  projectId,
  enableAnalytics: true,
});

const Header = () => {
  const { open } = useWeb3Modal();
  const [walletBalance, setWalletBalance] = useState(2000);
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const [isActive, setActive] = useState(false);
  // const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [user, setUser] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();
  const { walletProvider } = useWeb3ModalProvider();
  const codeSnippet = localStorage.getItem("WalletAddress");
  const SavedBalance = localStorage.getItem("balance");
  const { disconnect } = useDisconnect(); // Hook to disconnect the wallet

  const [loading, setLoading] = useState(false);


  const handleDisconnect = () => {
    disconnect(); // Disconnects the wallet
    console.log("Wallet disconnected");
  };
  const codeSnippets = localStorage.getItem("WalletBalance");
  const [link, setLink] = useState(null);
  const handleOpen = () => setOpen(true);
  const [opens, setOpen] = useState(false);
  const [balance, setBalance] = useState(null);
  const route = useNavigate();
  const toggleClass = () => {
    setActive(!isActive);
  };

  const [isCopied, setIsCopied] = useState(false);

  const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };
  const handleLoginLogout = () => {
    // console.log("flf", isConnected, SavedBalance);
    // if(SavedBalance){
    open();
  };

  const [searchBoxVisible, setSearchBoxVisible] = useState(false);

  // Handle visibility of search box
  const toggleSearchBox = () => {
    setSearchBoxVisible(!searchBoxVisible);

  };

  const handleGoAnotherpage = (prp) => {
    if (prp === "/logout") {
      handleDisconnect()
      localStorage.removeItem("WalletAddress");
      localStorage.removeItem("WalletBalance");
      localStorage.removeItem("UserId");
      setUser(null);
      navigate("/", { replace: true }); // Update the route
      window.location.reload(); // Reload the page
    }
    else {
      setLink(prp);
      codeSnippet !== null ? Redireaction(prp) : handleOpen();
    }
  };
  const navigate = useNavigate();

  const profileArr = [
    { title: "My Profile", icon: <CgProfile size={21} />, link: "/profile" },
    // { title: "Favorites", icon: <BiHeart size={21} />, link: "/" },
    {
      title: "My Collections",
      icon: <BsGrid3X3 size={20} />,
      link: "/collections",
    },
    { title: "Create", icon: <MdCreate size={21} />, link: "/mint" },
    // { title: "Settings", icon: <AiFillSetting size={21} />, link: "/settings" },
    { title: "Logout", icon: <BiLogOutCircle size={21} />, link: "/logout" },
  ];

  const handleCreateClick = () => {
    if (!isConnected) {
      setShowPopup(true);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };


  const Redireaction = (path) => {
    // console.log("path", path);
    
    if (!isConnected) {
      if (path === "/profile") {
        handleProfileNavigation()
      } else {
        route(path);
      }
    } else {
      route(path);
    }
  };

  const getBalance = async (provider) => {
    try {
      setLoading(true); // Start loading inside the try block
      const balanceWei = await provider.getBalance(address); // Fetch balance in Wei
      const balanceEther = GweiToether(balanceWei); // Convert Wei to Ether
      // console.log(balanceEther);

      // Simulate a 3-second delay for UX (optional)
      await new Promise((resolve) => setTimeout(resolve, 3000));
      localStorage.setItem("WalletBalance", balanceEther)
      setBalance(balanceEther); // Set the balance after delay`
    } catch (error) {
      console.error("Error fetching balance:", error); // Log error
      setBalance(null); // Set balance to null if an error occurs
    } finally {
      setLoading(false); // Stop loading after the function execution completes (success or failure)
    }
  };
  const closeSearchBox = () => {
    setSearchBoxVisible(false);
  };

  useEffect(() => {
    if (SavedBalance !== null) {
      setBalance(null)
    }
    if (isConnected) {
      localStorage.setItem("WalletAddress", address);
      localStorage.setItem("chainId", chainId);
      const provider = new BrowserProvider(walletProvider);
      localStorage.setItem("provider", provider);

      getBalance(provider)
      dispatch(setProvider(provider));
      dispatch(setWalletAddress(address));

      getUserByAddress(address).then((data) => {
        // console.log("address", data);

        setTimeout(() => {
          // hideLoader();
        }, 2000);
        if (data.status === 200) {
          setUser(data.user);
          localStorage.setItem("userId", data.user._id);
        } else {
          // window.location.reload(); // Reload the page
          route("/create-profile");
        }
      });
    } else {
      localStorage.removeItem("WalletAddress");
      localStorage.removeItem("chainId");
    }
  }, [isConnected]);

  const handleProfileNavigation = async (path) => {
    // console.log("path", path, isConnected);
    
    // Function to navigate to a given path
    if (path !== "/profile") {
        route(path); // Use the `useNavigate` function to navigate to the route
    }
    
    if (path === "/logout") {
      handleDisconnect()
      localStorage.removeItem("WalletAddress");
      localStorage.removeItem("WalletBalance");
      localStorage.removeItem("UserId");
      setUser(null);
      navigate("/", { replace: true }); // Update the route
      window.location.reload(); // Reload the page
    }
    else {
    // Step 1: Check if the wallet is connected
    if (isConnected && path === "/profile") {
      // Step 2: Check if the wallet address exists in the database
      // console.log("User", address);
      const user = await getUserByAddress(address);
      // console.log("User", user);
      
      if (user.status === 200) {
        // User is available; navigate to the desired route
        navigate("/profile");
      } else {
        toast.success("User not found.  Please Create your Profile.");
        route("/create-profile");
        // Optionally handle the case when the user is not found
      }
    } else {
      // Step 3: If not connected, open the popup for wallet connection
      setShowPopup(true);

      // Wait for the user to connect their wallet
      // const walletConnected = await waitForWalletConnection(); // A function to handle wallet connection logic

      // Step 4: Recheck wallet connection status and address availability
      // if (walletConnected) {
      //   const user = await getUserByAddress(walletAddress);
      //   if (user) {
      //     // User is available; navigate to the desired route
      //     navigate("/profile");
      //   } else {
      //     console.log("User not found in the database after connection.");
      //     // Optionally handle the case when the user is not found again
      //   }
      // } else {
      //   console.log("Wallet connection failed or canceled.");
      // }
    }
  }
};

return (
  <div>
    <header className="header__1">
      <div className="container">
        <div className="wrapper js-header-wrapper">
          <div className="header__logo">
            <Link to="/">
              <img
                className="header__logo"
                id="logo_js"
                src={Logo}
                alt="logo"
              />
            </Link>
          </div>
          <div className="header__menu">
            <ul className="d-flex space-x-20">
              {PagesMenu.map((val, i) => (
                <li
                  key={i}
                  onClick={() =>  Redireaction(val.link)}
                  style={{ cursor: "pointer" }}
                >
                  <span className="color_black">{val.title}</span>
                </li>
              ))}
              <li className="has_popup" onClick={handleCreateClick}>
                Create
                {isConnected ? (
                  <ul className="menu__popup space-y-20">
                    {HomesMenu.map((val, i) => (
                      <li key={i} style={{ cursor: "pointer" }}>
                        <Link to={val.link}>
                          <span className="mx-2">{val.icon}</span>
                          {val.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </li>
            </ul>
          </div>
          <div className="header__search">
            <input type="text" placeholder="Search" />
            <Link to="no-results" className="header__result">
              {/* <i className="ri-search-line" /> */}
              <FaSearch className="mt-2" />
            </Link>
          </div>
          <div className="d-flex ">
            <div className="header__btns mt-1">
              <div
                className="d-flex align-items-center justify-content-between"
                onClick={handleLoginLogout}
              >
                {loading ? (
                  <div className="processing glass-effect">
                    <div className="d-flex align-items-center">
                      <FaWallet size="1.2rem" className="connecting-icon" />
                      <span className="connecting-text ms-2">Connecting...</span>
                    </div>
                    <div className="spinner"></div>
                  </div>
                ) : balance ? (
                  <div className="wallet-balance">
                    <div className="wallet-balance-icon">
                      <FaWallet size="2em" />
                      <span>{balance} ETH</span>
                    </div>
                  </div>
                ) : (
                  <button className="login-btn">
                    <FaWallet size="2em" /> Login
                  </button>
                )}
              </div>
            </div>


            <div
              className="header__burger js-header-burger"
              onClick={toggleClass}
            />
            <div
              className={` header__mobile js-header-mobile  ${isActive ? "visible" : null
                } `}
            >
              <MobileMenu />
            </div>

            <div className="mx-3">
              <div className="Resource_main_class">
                {user === null ?
                  <img
                    className="avatar_org rounded-circle"
                    style={{ width: "2.5rem", height: "2.5rem" }}
                    src={DefaultProfile}
                    alt="avatar"
                  />
                  :
                  <img
                    className="avatar_org rounded-circle"
                    style={{ width: "2.5rem", height: "2.5rem" }}
                    src={user.profilePicture ? user.profilePicture : DefaultProfile}
                    alt="avatar"
                  />
                }
              </div>
              <div
                className="Resource_dropdown_class"
                style={{ marginLeft: "-6%" }}
              >
                <div className="avatar_popup avatar_Toggl1 p-3" id="dfsa">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="p4">
                      {" "}
                      {codeSnippet === null
                        ? `Wallet Address`
                        : `${codeSnippet.slice(0, 5)}...${codeSnippet.slice(
                          -5
                        )}`}
                    </span>

                    <CopyToClipboard
                      text={codeSnippet}
                      onCopy={onCopyText}
                      style={{ cursor: "pointer" }}
                    >
                      <span className="p3 ms-2">
                        {isCopied ? (
                          "Copied!"
                        ) : (
                          <MdContentCopy className="icons__size1" />
                        )}
                      </span>
                    </CopyToClipboard>
                  </div>
                  <div
                    className="d-flex align-items-center py-2"
                    style={{ marginTop: "-0.2rem" }}
                  >
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <ellipse
                        cx="17.6725"
                        cy="17.549"
                        rx="17.6725"
                        ry="17.549"
                        fill="url(#paint0_radial)"
                      />
                      <g clipPath="url(#clip0)">
                        <path
                          d="M17.8464 5.91772L17.6917 6.43055V21.3116L17.8464 21.4623L24.9309 17.3792L17.8464 5.91772Z"
                          fill="white"
                          fill-opacity="0.42"
                        />
                        <path
                          d="M17.8465 5.91772L10.762 17.3792L17.8465 21.4623V14.2395V5.91772Z"
                          fill="white"
                          fill-opacity="0.82"
                        />
                        <path
                          d="M17.8465 22.7702L17.7593 22.8739V28.1749L17.8465 28.4232L24.9353 18.6892L17.8465 22.7702Z"
                          fill="white"
                          fill-opacity="0.85"
                        />
                        <path
                          d="M17.8465 28.4231V22.7701L10.762 18.6891L17.8465 28.4231Z"
                          fill="white"
                          fill-opacity="0.47"
                        />
                        <path
                          d="M17.8464 21.4622L24.9309 17.3792L17.8464 14.2395V21.4622Z"
                          fill="white"
                          fill-opacity="0.63"
                        />
                        <path
                          d="M10.762 17.3791L17.8464 21.4622V14.2394L10.762 17.3791Z"
                          fill="white"
                        />
                      </g>
                      <defs>

                        <radialGradient
                          id="paint0_radial"
                          cx="0"
                          cy="0"
                          r="1"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(18.7772) rotate(91.8025) scale(35.1156 35.3624)"
                        >
                          <stop stop-color="#31E7FA" />
                          <stop offset="0.526042" stop-color="#4477FF" />
                          <stop offset="1" stop-color="#DB74FF" />
                        </radialGradient>
                        <clipPath id="clip0">
                          <rect
                            width="14.1733"
                            height="22.5105"
                            fill="white"
                            transform="translate(10.762 5.91772)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <h5 className="w-full align-items-center text-sm mx-2 font-bold text-green-500">
                      {codeSnippets !== null && codeSnippets !== undefined
                        ? `${parseFloat(codeSnippets.slice(0, 9)).toFixed(
                          4
                        )} ETH`
                        : "0.000 ETH"}
                    </h5>
                  </div>
                  <div className="d-flex flex-column">
                    {profileArr.map((data) => (
                      <div
                        className="d-flex text-dark align-item-center text-sm py-1 link"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleProfileNavigation(`${data.link}`)
                        }
                      >
                        <div className="d-flex align-items-center ">
                          <div className="mr-2">{data.icon}</div>
                          <div style={{ marginBottom: "-0.5rem" }}>
                            <h6 className="ms-2"> {data.title}</h6>
                          </div>
                        </div>
                      </div>

                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <ToastContainer position="bottom-right"/>

    <Modal
      show={showPopup}
      // size="lg"
      onHide={closePopup}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Connect Wallet
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h3>Please connect your wallet !!!</h3>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            closePopup();
            open();
          }}
        >
          {" "}
          Connect Wallet
        </Button>
        <Button onClick={closePopup}>Close</Button>
      </Modal.Footer>
    </Modal>
  </div>
);
};

export default Header;